import Duck from 'extensible-duck'

const initialState = {}

const types = ['INIT_STATE', 'RESET']

export default new Duck({
  namespace: 'content',
  store: 'dailyCheckIn',
  types,
  initialState,
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.INIT_STATE:
        return { ...action.payload }
      case duck.types.RESET:
        return initialState
      default:
        return state
    }
  },
  creators: (duck) => ({
    reset: () => ({ type: duck.types.RESET }),
    initDailyCheckInState: (payload) => ({
      type: duck.types.INIT_STATE,
      payload,
    }),
  }),
})
